import { KeyImage } from '../services/imaging/common';
import { ISeSideExaminationStudy } from '../se-side/se-side-components/se-side-key-images-container/se-side-key-images-models';

export interface SeReportState {
    patientId: string | null;
    currentExaminationIds: {
        ecg: string[];
        visit: string[];
    };
    isModified: boolean;
    isReadonly: boolean;
    keyImages: KeyImage[];
    isPreview: boolean;
    imagesPerRowInPlaceholder : number;
    conclusions? : string;
    examinationStudies: ISeSideExaminationStudy[];
}

export const seReportInitialState: SeReportState = {
    keyImages: [],
    currentExaminationIds: {
        ecg: [],
        visit: [],
    },
    isModified: false,
    isReadonly: true,
    patientId: null,
    isPreview: false,
    imagesPerRowInPlaceholder: 1,
    conclusions: '',
    examinationStudies: []
};
